module.exports = __webpack_public_path__ + "static/media/001.d5d66071.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/001.jpg
// module id = 1576
// module chunks = 0